<template>
    <Modal @close="$emit('close')">
      <div slot="body">
        <!-- Typography Section -->
        <div class="settings-section">
          <h3 class="section-title">
            <i class="fas fa-text-height" aria-hidden="true"></i>
            {{ $t("typography_settings") }}
          </h3>
          <button class="buttons primary-button" @click="$emit('font_plus')">
            <i class="fas fa-plus-circle" aria-hidden="true"></i>
            {{ $t("font_plus") }}
          </button> <br>
          <button class="buttons primary-button" @click="$emit('font_less')">
            <i class="fas fa-minus-circle" aria-hidden="true"></i>
            {{ $t("font_less") }}
          </button> <br>
        </div>

        <!-- Social & Links Section -->
        <div class="settings-section">
          <h3 class="section-title">
            <i class="fas fa-link" aria-hidden="true"></i>
            {{ $t("links") }}
          </h3>
          <button @click="open_gplay" class="buttons secondary-button">
            <i class="fab fa-android" aria-hidden="true"></i>
            Android App
          </button><br>
          <button @click="open_instagram" class="buttons secondary-button">
            <i class="fab fa-instagram" aria-hidden="true"></i>
            Instagram
          </button><br>
        </div>

        <!-- Offline Mode Section -->
        <div class="offline-section">
          <h3 class="offline-title">{{ $t("offline_mode") }}</h3>
          <p class="offline-count">
            {{ $t("offline_stories_available") }}: <strong>{{ offlineStoriesCount }}</strong>
          </p>

          <button
            @click="downloadOffline"
            class="buttons offline-button"
            :disabled="isDownloadingOffline">
            <span v-if="!isDownloadingOffline">{{ $t("download_offline") }}</span>
            <span v-else>{{ $t("downloading") }}... {{ downloadProgress }}%</span>
          </button><br>

          <button
            v-if="offlineStoriesCount > 0"
            @click="clearOffline"
            class="buttons clear-button">
            {{ $t("clear_offline_stories") }}
          </button><br>

          <p class="offline-hint">{{ $t("offline_hint") }}</p>
        </div>

        <button @click="reset_preferences" class="buttons warning-button">
          <i class="fas fa-redo" aria-hidden="true"></i>
          {{$t("reset_preferences_title")}}
        </button><br>

        <div style="padding-top: 20px;">{{$t("authorship")}}</div>
      </div>
              
    </Modal>
</template>

<script>
import Modal from './Modal.vue'
export default {
  name: 'Settings',
  components: {
    Modal
  },
  data () {
    return {
      showModal: false
    }
  },
  props: {
    name: String,
    parent: String,
    offlineStoriesCount: {
      type: Number,
      default: 0
    },
    isDownloadingOffline: {
      type: Boolean,
      default: false
    },
    downloadProgress: {
      type: Number,
      default: 0
    }
  },

  methods: {
    downloadOffline() {
      // Ask user how many stories to download
      const count = prompt(this.$t("offline_download_prompt"), "5");
      if (count && !isNaN(count) && count > 0) {
        this.$emit('download_offline', parseInt(count));
      }
    },

    clearOffline() {
      if (confirm(this.$t("confirm_clear_offline"))) {
        this.$emit('clear_offline');
      }
    },
    open_gplay() {
      window.open('https://play.google.com/store/apps/details?id=org.legi', '_blank');
    },

    open_instagram() {
      window.open('https://instagram.com/legi.app', '_blank');
    },

    reset_preferences() {
      localStorage.setItem('user_random_id', '');
      alert(this.$t("reset_preferences"));
    }
  }
}
</script>

<style scoped>

.buttons {
  -webkit-border-radius: 6;
  -moz-border-radius: 6;
  border-radius: 6px;
  font-family: Arial;
  color: #00073F;
  font-size: 20px;
  padding: 10px 20px 10px 20px;
  border: solid #00073F 2px;
  text-decoration: none;
  width: 30vh;
  margin: 1vh
}

button:hover {
  text-decoration: none;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.offline-section {
  border-top: 2px solid #e0e0e0;
  border-bottom: 2px solid #e0e0e0;
  padding: 20px 10px;
  margin: 20px 0;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.offline-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #00073F;
}

.offline-count {
  font-size: 16px;
  margin-bottom: 15px;
}

.offline-count strong {
  color: #3498db;
  font-size: 20px;
}

.offline-button {
  background-color: #3498db !important;
  color: white !important;
  border-color: #3498db !important;
}

.offline-button:hover:not(:disabled) {
  background-color: #2980b9 !important;
}

.clear-button {
  background-color: #e74c3c !important;
  color: white !important;
  border-color: #e74c3c !important;
}

.clear-button:hover {
  background-color: #c0392b !important;
}

.offline-hint {
  font-size: 12px;
  color: #666;
  font-style: italic;
  margin-top: 10px;
  line-height: 1.4;
}

li {
  display: block;
}

.settings-section {
  padding: 15px 10px;
  margin: 15px 0;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #00073F;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title i {
  font-size: 20px;
}

.primary-button {
  background-color: #3498db !important;
  color: white !important;
  border-color: #3498db !important;
}

.primary-button:hover:not(:disabled) {
  background-color: #2980b9 !important;
}

.secondary-button {
  background-color: #9b59b6 !important;
  color: white !important;
  border-color: #9b59b6 !important;
}

.secondary-button:hover:not(:disabled) {
  background-color: #8e44ad !important;
}

.warning-button {
  background-color: #f39c12 !important;
  color: white !important;
  border-color: #f39c12 !important;
}

.warning-button:hover:not(:disabled) {
  background-color: #e67e22 !important;
}
</style>
